
window.onload = function () {
    window.sr = ScrollReveal({ 
        //reset: true,
        mobile: true
    });

    const sr = ScrollReveal();

    // 画面幅によって viewOffset を切り替え
    const isMobile = window.innerWidth <= 768;

    const viewOffsetValue = isMobile
    ? { top: 100, bottom: 100 }
    : { top: 250, bottom: 250 };

    /* 共通 */
    /*sr.reveal('.firstview video', { 
        origin: 'bottom',
        distance: '0px',
        duration: 1500,
        opacity: 0
    });*/
    sr.reveal('.img_block', { 
        origin: 'bottom',
        distance: '0px',
        duration: 1500,
        opacity: 0,
        viewOffset: viewOffsetValue
    });
    sr.reveal('.txt_block', { 
        origin: 'bottom',
        distance: '0px',
        duration: 1500,
        delay:250,
        opacity: 0,
        viewOffset: viewOffsetValue
    });
    /*sr.reveal('footer .slide', { 
        origin: 'bottom',
        distance: '0px',
        duration: 1000,
        opacity: 0,
        viewOffset: { top: 100, bottom: 100 }
    });*/
    sr.reveal('footer', { 
        origin: 'bottom',
        distance: '0px',
        duration: 1000,
        opacity: 0
    });
    
};
